export default __webpack_public_path__ + "static/media/Resume.ab9f1f07.pdf";